import React from "react"
import { Redirect, Switch, useLocation } from "react-router"
import PublicRoute from "./PublicRoute"
import ChangePassword from "../../pages/auth/ChangePassword"
import Login from "../../pages/auth/Login"
import ResetPassword from "../../pages/auth/ResetPassword"
import SignUp from "../../pages/auth/SignUp"
import { checkLogin } from "../../utils/ApiUtils"

export const AuthRoutesList = [
  {
    path: "/login",
    exact: true,
    component: Login
  },
  {
    path: "/sign-up",
    exact: true,
    component: SignUp
  },
  {
    path: "/reset",
    exact: true,
    component: ChangePassword
  },
  {
    path: "/reset-password",
    exact: true,
    component: ResetPassword
  },

  {
    path: "/get-started",
    exact: true,
    component: ({ location }) => {
      // const location = useLocation()

      return checkLogin() ? (
        <Redirect to="/create-event" />
      ) : (
        <Redirect to={{ pathname: "/sign-up", state: { from: location } }} />
      )
    }
  }
]

const AuthRoutes = () => {
  return (
    <Switch>
      {AuthRoutesList.map(r => (
        <PublicRoute
          component={r.component}
          path={r.path}
          exact={r.exact}
          key={r.path}
          // render
        />
      ))}
    </Switch>
  )
}

export default AuthRoutes
